import { call, put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';

export function* postIntakeSubmission(action): Generator<any, void, empty> {
  const actionId = action?.id;
  try {
    const response = yield call(() => APIService.apiRequest('POST_INTAKE_SUBMISSION', 'POST', {
      body: action?.body ?? {},
    }));
    yield put({
      type: ActionTypes.intake.postIntakeSubmission.SUCCESS,
      id: response?._id,
      response,
    });
  } catch (error) {
    yield put({
      types: ActionTypes.intake.postIntakeSubmission.ERROR,
      id: actionId,
      error,
    });
  }
}
